<template>
  <a class="dropdown-item cursor-pointer" @click="handle">Reply</a>
</template>

<script>
import eventBus from "../../../event-bus";

export default {
  props: {
    message: Object,
  },

  methods: {
    /**
     * @return {void}
     */
    handle() {
      eventBus.$emit('reply-to-email', {message: this.message});
    },
  },
}
</script>

<style scoped>

</style>
